export interface AppConfig {
  API_BASE_URL: string;
  API_TOKEN: string;
}

let config: AppConfig;

export async function loadConfig() {
  const response = await fetch("/config.json");

  if (!response.ok) {
    throw new Error("Failed to load config");
  }

  config = await response.json();
}

export function getConfig() {
  if (!config) {
    throw new Error("Config not loaded");
  }

  return config;
}
